import { api } from "../../../api/apiSlice";

export const departmentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDepartments: builder.query({
      query: () => ({ url: "/masters/departments" }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((d) => ({ type: "HrDepartments", id: d.departmentCode })),
              { type: "HrDepartments", id: "LIST" },
            ]
          : [{ type: "HrDepartments", id: "LIST" }],
    }),
    createDepartment: builder.mutation({
      query: (body) => ({ url: "/masters/departments", method: "POST", data: body }),
      invalidatesTags: [{ type: "HrDepartments", id: "LIST" }],
    }),
    updateDepartment: builder.mutation({
      query: ({ code, ...body }) => ({
        url: `/masters/departments/${code}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: [{ type: "HrDepartments", id: "LIST" }],
    }),
    deleteDepartment: builder.mutation({
      query: (code) => ({ url: `/masters/departments/${code}`, method: "DELETE" }),
      invalidatesTags: [{ type: "HrDepartments", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDepartmentsQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
} = departmentsApi;
